export default __webpack_public_path__ + "static/media/search.d993ef23.svg";